<template>
	<div class="page-users page-content" v-loading="body_loading">
		<div class="main-body">
			<el-row class="hd">
				<el-col :span="24">
					<h3 style="float: none;">用户管理</h3>
					<div class="flex-block breadcrumb-box">
						<div class="position-text">位置：</div>
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item>用户管理</el-breadcrumb-item>
							<el-breadcrumb-item>用户列表</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
				</el-col>
			</el-row>
			<div class="bd">
				<div class="search-block content-body">
					<el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline"
						@submit.native.prevent>
						<el-form-item prop="userName" label="名字：" style="margin-bottom: 0;">
							<el-input v-model="form_search.userName" size="small" placeholder="名字" clearable></el-input>
						</el-form-item>
						<el-form-item prop="mobilePhone" label="用户手机号：">
							<el-input v-model="form_search.mobilePhone" type='number' size="small" placeholder="用户手机号"
								clearable></el-input>
						</el-form-item>
						<el-form-item prop="loginId" label="登录账号：">
							<el-input v-model="form_search.loginId" size="small" placeholder="登录账号"
								clearable></el-input>
						</el-form-item>
						<el-form-item prop="sex" label="性别：">
							<el-select size="small" v-model="form_search.sex" placeholder="请选择" style="width:100%;">
								<el-option v-for="item in init_data.sex_list" :key="item.id" :label="item.name"
									:value="item.name">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item prop="orgId" label="所属部门：">
							<el-select size="small" v-model="form_search.orgId" placeholder="请选择" style="width:100%;">
								<el-option v-for="item in init_data.type_list" :key="item.icode" :label="item.fullName"
									:value="item.icode">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item prop="orgName" label="部门名称：">
							<el-input v-model="form_search.orgName"  size="small" placeholder="部门名称"
								clearable></el-input>
						</el-form-item>
						<el-form-item prop="status" label="状态：">
							<el-select size="small" v-model="form_search.status" placeholder="请选择" style="width:100%;">
								<el-option v-for="item in init_data.status_list" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item prop="userType" label="用户类型：">
							<el-select size="small" v-model="form_search.userType" placeholder="请选择" style="width:100%;">
								<el-option v-for="item in init_data.userType_list" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item style="margin-bottom: 0;">
							<el-button type="primary" class="search-btn" size="medium" @click='searchList()'>查询
							</el-button>
						</el-form-item>
					</el-form>
					
					
				</div>
				<div class="table-block content-body">
					<div class="" style="display: flex;flex-direction: row;justify-content: flex-end;">
						<el-button type="primary" class="search-btn" size="medium" @click="handleUser('add')">添加用户
						</el-button>
					</div>
					<div ref="contentBody">
						
						
						<el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading"
							tooltip-effect="dark" style="width: 100%;text-align: center;">
							
							<el-table-column prop="loginId" align="center" label="登录账户" min-width="160">
							</el-table-column>
							
							<el-table-column prop="userName"  align="center" label="用户名字" min-width="100">
							</el-table-column>
							<el-table-column prop="mobilePhone"  align="center" label="手机号码" min-width="160">
								
							</el-table-column>
							<el-table-column prop="sex" align="center" label="性别" min-width="120">
							</el-table-column>

							<el-table-column prop="userType" align="center" label="用户类型" min-width="140">
								<template slot-scope="scope">
									<span>{{scope.row.userType==1?'在编':scope.row.userType==2?'外包':scope.row.userType==3?'来湛出差人员':'物业公务班组'}}</span>
								</template>
							</el-table-column>

						     <el-table-column prop="listAllorg" align="center" label="部门名称" min-width="280">
                                <template slot-scope="scope">
									<div class="" v-for="(item) in scope.row.listAllOrg">
										{{item.orgFullName}}
									</div>
                                   
                                </template>
                            </el-table-column>
                           
							<el-table-column prop="status" align="center" label="状态" min-width="120">
								<template slot-scope="scope">
									<span :class="'status-'+scope.row.status">{{scope.row.statusText}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="isDelete" align="center" label="是否删除" min-width="120">
								<template slot-scope="scope">
									<span :class="'status-'+scope.row.isDelete">{{scope.row.isDeleteText}}</span>
								</template>
							</el-table-column>
							
							<el-table-column prop="operating" align="center" label="操作" min-width="180" fixed="right">
								<template slot-scope="scope">
									
									<el-button class="option-btn btn-bd-r" type="primary" size="mini" @click="resetPsd(scope.row.icode)">重置密码</el-button>
									<el-button class="option-btn btn-bd-s" type="primary" size="mini"
										@click="handleUser('edit',scope.row)">编辑用户</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="table_data.page_info.page" :page-sizes="[10,30, 50,80,100]"
						:page-size="table_data.page_info.pageSize" layout="total, sizes, prev, pager, next"
						:total="table_data.page_info.total">
					</el-pagination>
				</div>
			</div>
			<!-- 用户编辑弹窗-->
			<el-dialog class="dialog-export card-dialog" :title="dlg_card.title" :visible.sync="dlg_card.visible"
				width="534px" @closed="closeCard" :close-on-click-modal="false">
				<el-form ref="formCard" :model="dlg_card.form" label-width="110px" :rules="dlg_card.rules"
					@submit.native.prevent>
					<el-form-item prop="loginId" label="登录账号：">
						<el-input size="small" v-model="dlg_card.form.loginId" placeholder='请输入登录账号' clearable>
						</el-input>
					</el-form-item>
					<el-form-item prop="userName" label="用户名：" >
						<el-input size="small" v-model="dlg_card.form.userName" placeholder='请输入用户名' clearable>
						</el-input>
					</el-form-item>
					<el-form-item prop="mobilePhone" label="手机号码：">
						<el-input size="small"  v-model="dlg_card.form.mobilePhone" placeholder='请输入手机号码' clearable>
						</el-input>
					</el-form-item>
					<el-form-item prop="sex" label="性别：">
						<el-select size="small" v-model="dlg_card.form.sex" placeholder="请选择" style="width:100%;">
							<el-option v-for="item in init_data.sex_list" :key="item.id" :label="item.name"
								:value="item.name">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="userType" label="用户类型：">
						<el-select size="small" v-model="dlg_card.form.userType" placeholder="请选择" style="width:100%;">
							<el-option v-for="item in init_data.userType_list" :key="item.id" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="status" label="状态：">
						<el-select size="small" v-model="dlg_card.form.status" placeholder="请选择" style="width:100%;">
							<el-option v-for="item in init_data.status_list" :key="item.id" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item prop="listOrgStr" label="所属部门：">
						<el-select size="small" v-model="dlg_card.form.listOrgStr" placeholder="请选择" style="width:100%;">
							<el-option v-for="item in init_data.type_list" :key="item.icode" :label="item.fullName"
								:value="item.fullName">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="角色：" >
					    <div style="padding: 10px;border-radius: 4px;border: 1px solid #DCDFE6;">
					        <!-- <el-checkbox v-model="dlg_role.optionchecked" @change="getOptionAuth"/> 全选/取消 -->
					        <div style="height: 200px;overflow: auto;">
								<el-tree
								
								        :data="dlg_role.data"
								        show-checkbox
								        node-key="roleKey"
								        ref="roleTree"
								        :default-expand-all="true"
								        :default-checked-keys="dlg_role.default_list"
								        :check-on-click-node="true"
								        :props="dlg_role.defaultProps">
										
								</el-tree>
								
					       </div>
					    </div>
					</el-form-item>
					<el-form-item prop="isDelete" label="是否删除：">
					    <el-radio-group v-model="dlg_card.form.isDelete">
					        <el-radio v-for="(item, index) in dlg_card.init_data.show_name_list" :key="index" :label="item.id">{{item.name}}</el-radio>
					    </el-radio-group>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="dlg_card.visible = false">取 消</el-button>
					<el-button type="primary" @click="submitUser()" :loading="dlg_card.btn_loading">确认</el-button>
				</span>
			</el-dialog>
			
			
			<!-- 图片放大 -->
			<el-dialog :visible.sync="dlg_preview.visible" class="dialog-no-title text-center" width="420px">
				<img width="100%" :src="dlg_preview.img_url" style="max-width:100%;">
			</el-dialog>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'usercenter',
		data() {
			return {
				clientHeight: '',
				body_loading: false,
				is_refresh: true,
				form_search: {
					
					mobilePhone: "",
					sex: '',
					userName: '',
					orgId: '',
					status:'',
					orgName:'',
					loginId:'',
					userType:''
				},
				init_data: {
					status_list: [
						{id:0, name: '禁用'},{id:1, name: '启用'}
					],
					type_list: [],
					sex_list:[{id:0, name: '女'},{id:1, name: '男'},],
					userType_list:[{id:"1", name: '在编'},{id:"2", name: '外包'},{id:"4", name: '物业公务班组'},{id:"3", name: '来湛出差人员'}]
				},
				is_master_show: false,
				table_data: {
					loading: false,
					list: [],
					page_info: {
						page: 1,
						pageSize: 10,
						total: 130
					}
				},
				
				
				dlg_card: {
					id: '',
					visible: false,
					btn_loading: false,
					api: '',
					title: '',
					form: {
						loginId: '',
						userName:'',
						mobilePhone:'',
						status:1,
						roleKeys:'',
						isDelete:0,
						listOrgStr:'',
						listOrg:[],
						sex:'',
						icode:'',
						userType:''

					},
					error: {
						loginId: '',
				
					},
					reset_form: {},
					init_data: {
						status_list: [],
						 show_name_list:[{id:1, name: '开启'},{id:0, name: '关闭'}]
					},
					rules: {
							loginId: {required: true,message: '登录账户不能为空'},
							userName:{required: true,message: '用户名不能为空'},
							mobilePhone:{required: true,message: '手机号码不能为空'},
							status:{required: true,message: '请选择状态'},
							sex:{required: true,message: '请选择性别'},
							userType:{required: true,message: '请选择用户类型'},

							isDelete:{required: true,message: '请选择是否删除'},
							listOrgStr:{required: true,message: '请选择所属部门'},
					},
					params: {
						headers: {
							token: localStorage.getItem('token')
						}
					}
				},
				
				dlg_preview: {
					visible: false,
					img_url: ''
				},
				dlg_role:{
					data:[],
					defaultProps: {
					    children: 'children',
					    label: 'name',
						// roleKey:'roleKey'
					},
					default_list:[]
				},
			}
		},
		created() {
			document.title = '用户列表';
			this.getList();
			this.getOrgList()
			this.getRoleList()
		},
		methods: {
			
			//查询
			searchList() {
				var _this = this;
				_this.table_data.page_info.page = 1;
				_this.getList();
			},
			getRoleList() {
			    var _this = this;
			    this.$client.get('/api/sys/role/getTreeForAdmin', {}, function(res,message){
					_this.dlg_role.data=res
			    },function(res){
			      
			    });
			},
			getOrgList(){
				
				var _this = this;
				var org_list=[]
				_this.$client.get('/api/sys/org/getListForAdmin', {}, function(res, message) {
					
					_this.init_data.type_list = org_list.concat(res)
					console.log(_this.init_data.type_list ,"部门组织列表")
				}, function(res) {
					
				});
			},
			getList() {
				var _this = this;
				var params = _this.form_search;
				params.pageNo = _this.table_data.page_info.page;
				params.pageSize = _this.table_data.page_info.pageSize;
				_this.table_data.loading = true;
				
				
				this.$client.get('/api/sys/user/getListForAdmin', params, function(res, message,total,totalPages) {
					_this.table_data.list = res;
					//_this.table_data.page_info.page = totalPages;
					_this.table_data.page_info.total = total;
					
					_this.table_data.loading = false;
				}, function(res) {
					_this.table_data.loading = false;
				});
			},
			handleUser(type, data) {
				this.dlg_card.visible = true;
				this.dlg_role.default_list=[]
				if (type == 'add') {
					this.dlg_card.title = '添加用户';
					this.dlg_card.api = '/api/sys/user/create';
				} else {
					this.dlg_card.id = data.id;
					this.dlg_card.title = '编辑用户';
					if (data) {
						for (var key in this.dlg_card.form) {
							this.dlg_card.form[key] = data[key];
							if(key=='listOrg'){
								this.init_data.type_list.forEach((item)=>{
									 data.listAllOrg.forEach((itema)=>{
										 if(itema.orgId==item.icode){
											 this.dlg_card.form.listOrgStr=item.fullName
										 }
									 })
								})
								console.log(this.dlg_card.form.listOrgStr,"this.dlg_card.form.listOrgStr")
							}
							if(key=='roleKeys'){
								this.dlg_role.default_list=data.roleKeys.split(',')
							}
						}
					}
					this.dlg_card.api = '/api/sys/user/update';
				}
			},
			handleSizeChange(val) {
				this.table_data.page_info.pageSize = val;
				this.getList();
			},
			handleCurrentChange(val) {
				this.table_data.page_info.page = val;
				this.getList();
			},
			
			submitUser() {
				 
				var _this = this;
				 var role_arr = _this.$util.getCheckedKeys(_this.dlg_role.data, _this.$refs.roleTree.getCheckedKeys(), 'roleKey');
				_this.dlg_role.default_list=role_arr
			
				if(_this.dlg_card.form.listOrgStr !=''){
					
					_this.dlg_card.form.listOrg=[]
					_this.init_data.type_list.forEach((item)=>{
						if(_this.dlg_card.form.listOrgStr==item.fullName){
							_this.dlg_card.form.listOrg.push({
								orgId:item.icode,
								toType:1
							})
						}
					})
				}
				 _this.dlg_card.form.roleKeys = role_arr.join(",");
				 	console.log(role_arr,_this.dlg_card.form.listOrg,"点击提交")
				 console.log(_this.dlg_role.default_list, _this.dlg_card.form.roleKeys,"所勾选角色")
				_this.$refs['formCard'].validate((valid) => {
					if (valid) {
						this.dlg_card.btn_loading = true;
						this.$client.post(this.dlg_card.api, this.dlg_card.form, function(res, message) {
							_this.$message(message);
							_this.getList();
							_this.dlg_card.btn_loading = false;
							_this.dlg_card.visible = false;
						}, function(message) {
							_this.dlg_card.btn_loading = false;
							if ((typeof message) === 'object') {
								for (var key in message) {
									_this.dlg_card.error[key] = message[key];
								}
							}
						});
					} else {
						return false;
					}
				});
			},
			//删除用户
			 resetPsd(id){
				var _this = this;
				this.$confirm('确定要重置用户密码？', "", {
							confirmButtonText: "确定",
							cancelButtonText: "取消",
							iconClass:"icon-delete el-icon-delete",
							customClass:"my-confirm-box",
							center: true,
						})
						.then(() => {
					_this.$client.post('/api/sys/user/resetPassword', {icode:id}, function(res,message){
						// _this.$util.ta
					_this.getList();
					
				},function(res){

				});
			})
			.catch(() => {});
			},
			closeCard() {
				this.dlg_card.img_list = [];
				this.dlg_card.hide_upload = false;
				for (var key in this.dlg_card.form) {
					this.dlg_card.form[key] = this.dlg_card.reset_form[key];
				}
				this.$nextTick(() => {
					this.$refs.formCard.clearValidate();
				})
			},
			
		
			changeFixed(clientHeight) {
				this.$refs.contentBody.style.minHeight = (clientHeight - 394) + 'px';
			}
		},
		mounted() {
			// 获取浏览器可视区域高度
			this.clientHeight = `${document.documentElement.clientHeight}` //document.body.clientWidth;
			window.onresize = function temp() {
				this.clientHeight = `${document.documentElement.clientHeight}`;
			};
		},
		watch: {
			// 如果 `clientHeight` 发生改变，这个函数就会运行
			clientHeight: function() {
				this.changeFixed(this.clientHeight)
			}
		}
	}
</script>
<style>

</style>
<style scoped>
	.balance-title {
		text-align: center;
		font-size: 18px;
		color: #161616;
	}

	.balance-text {
		font-size: 14px;
		color: #161616;
		padding: 20px;
		text-align: center;
		margin-bottom: 20px;
	}

	.balance-text span {
		font-size: 24px;
	}
</style>
